/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OperationsLimitDTO } from './OperationsLimitDTO';
import {
    OperationsLimitDTOFromJSON,
    OperationsLimitDTOFromJSONTyped,
    OperationsLimitDTOToJSON,
} from './OperationsLimitDTO';

/**
 * 
 * @export
 * @interface OperationsLimitTraitDTO
 */
export interface OperationsLimitTraitDTO {
    /**
     * 
     * @type {Array<OperationsLimitDTO>}
     * @memberof OperationsLimitTraitDTO
     */
    limits: Array<OperationsLimitDTO>;
}

/**
 * Check if a given object implements the OperationsLimitTraitDTO interface.
 */
export function instanceOfOperationsLimitTraitDTO(value: object): value is OperationsLimitTraitDTO {
    if (!('limits' in value) || value['limits'] === undefined) return false;
    return true;
}

export function OperationsLimitTraitDTOFromJSON(json: any): OperationsLimitTraitDTO {
    return OperationsLimitTraitDTOFromJSONTyped(json, false);
}

export function OperationsLimitTraitDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationsLimitTraitDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'limits': ((json['limits'] as Array<any>).map(OperationsLimitDTOFromJSON)),
    };
}

export function OperationsLimitTraitDTOToJSON(value?: OperationsLimitTraitDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'limits': ((value['limits'] as Array<any>).map(OperationsLimitDTOToJSON)),
    };
}

